/**
 * Shown when an authenticated user navigates to a route that requires a higher
 * role than they hold. Distinct from `NotFound` — the resource exists, the
 * user just doesn't have permission to view it.
 *
 * Shell: (desktop). Rendered by RequireRole when the role check fails.
 */
import { Button, Center, Stack, Text, ThemeIcon, Title } from '@mantine/core';
import { IconLock } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';

export function ForbiddenPage() {
  const navigate = useNavigate();
  return (
    <Center style={{ minHeight: '60vh' }}>
      <Stack align="center" gap="md" maw={400}>
        <ThemeIcon size={64} radius="xl" variant="light" color="red">
          <IconLock size={32} stroke={1.5} />
        </ThemeIcon>
        <Title order={2} ta="center">
          Access restricted
        </Title>
        <Text c="dimmed" ta="center">
          You don't have permission to view this page. Contact your shop owner if you believe this
          is a mistake.
        </Text>
        <Button variant="default" onClick={() => navigate(-1)}>
          Go back
        </Button>
      </Stack>
    </Center>
  );
}
